module.exports = __webpack_public_path__ + "static/media/category8.1320369e.png";